import optional from "../../../../../common/Helper/Support/Optional";

export const organizeOrganizationStructure = data => organizeNode(data);

const organizeNode = department => {
    const children = (department.child_departments || []).map(child => organizeNode(child));

    const directCount = Number(department.users_count) || 0;
    const totalCount = directCount + children.reduce((sum, child) => sum + child.count, 0);

    return {
        id: department.id,
        name: department.name,
        title: optional(department, 'manager', 'full_name'),
        direct_count: directCount,
        count: totalCount,
        children,
    };
}
